import { render, staticRenderFns } from "./CheckFields.vue?vue&type=template&id=a50ffa8a&scoped=true&"
import script from "./CheckFields.vue?vue&type=script&lang=js&"
export * from "./CheckFields.vue?vue&type=script&lang=js&"
import style0 from "./CheckFields.vue?vue&type=style&index=0&id=a50ffa8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50ffa8a",
  null
  
)

export default component.exports